import { getAssert } from "../utils/Safe";
import FlumpMovieSymbol from "./symbols/FlumpMovieSymbol";
import FlumpAtlasSymbol from "./symbols/FlumpAtlasSymbol";
import FlumpClip from "./display/FlumpClip";
import FlumpSubClip from "./display/FlumpSubClip";

/**
 * Flump library file. Create only one per flump atlas and keep a reference to it.
 */
export default class FlumpLibrary
{
    /** 
     * @param {Phaser.Game} game A reference to an active Phaser.Game instance.
     * @param {*} json Flump json file (library.json).
     * @param {string} baseDirectory Base directory of the flump atlases.
     */
    constructor(game, json, baseDirectory)
    {
        /**
         * @type {number}
         */
        this.frameRate = getAssert([json, "frameRate"], "[FlumpLibrary] Cannot find frame rate value in library.json.");

        /**
         * @type {Object.<string, FlumpMovieSymbol>}
         */
        this.movieClips = { };

        let symbolCount = getAssert([json, "movies", "length"], "[FlumpLibrary] Cannot find frame rate value in library.json.");
        this.movieSymbols = new Array(symbolCount);

        // Private Members

        /**
         * @type {Phaser.Game}
         * @private
         */
        this.game = game;
        
        for(let i = 0; i < json.movies.length; i++)
        {
            this.movieSymbols[i] = json.movies[i].id;
            this.movieClips[this.movieSymbols[i]] = new FlumpMovieSymbol(this, json.movies[i]);
        }
        
        let textureGroups = json.textureGroups;
        this.atlases = new Array();
        
        for(let i = 0; i < textureGroups[0].atlases.length; i++)
        {            
            this.atlases.push(new FlumpAtlasSymbol(this.game, textureGroups[0].atlases[i], baseDirectory));
        }
    }

    /**
     * Cleans up the library.
     */
    destroy()
    {
        if (this.movieClips != null)
        {
            for (let i = 0; i < this.movieSymbols.length; i++)
            {
                if (this.movieClips.hasOwnProperty(this.movieSymbols[i]))
                {
                    this.movieClips[this.movieSymbols[i]].destroy();
                    delete this.movieClips[this.movieSymbols[i]];
                }
            }
            this.movieSymbols = null;
            this.movieClips = null;
        }

        if (this.atlases != null)
        {
            while (this.atlases.length > 0)
            {
                this.atlases[0].destroy();
                this.atlases.shift();
            }
            this.atlases = null;
        }

        this.game = null;
    }
    
    /**
     * Returns a clip from the library.
     * @param {string} [defaultClip] Default clip that plays.
     * @returns {FlumpClip}
     */
    createClip(defaultClip = null)
    {
        return new FlumpClip(this.game, this.movieClips, this, defaultClip);
    }
    
    /**
     * Returns a subclip from the library.
     * @param {string} [defaultClip] Default clip that plays.
     * @returns {FlumpSubClip}
     */
    createSubClip(defaultClip, layer, movieClip)
    {
        return new FlumpSubClip(this.game, this.movieClips, this, defaultClip, layer, movieClip);
    }
    
    /**
     * Returns a sprite from the library.
     * @param {string} spriteName 
     */
    getSprite(spriteName)
    {
        for(let i = 0; i < this.atlases.length; i++)
        {            
            let sprite = this.atlases[i].getSprite(spriteName);

            if(sprite != null)
            {
                return sprite;
            }
        }

        return null;
    }
}